;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/vendors/category/:hubSlug\",\"regex\":\"^/vendors/category/([^/]+)$\",\"paramNames\":[\"hubSlug\"],\"hasOptionalPrefix\":false},{\"path\":\"/vendors/:slug\",\"regex\":\"^/vendors/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/properties/:key\",\"regex\":\"^/properties/([^/]+)$\",\"paramNames\":[\"key\"],\"hasOptionalPrefix\":false},{\"path\":\"/agents/language/:hubSlug\",\"regex\":\"^/agents/language/([^/]+)$\",\"paramNames\":[\"hubSlug\"],\"hasOptionalPrefix\":false},{\"path\":\"/agents/:slug\",\"regex\":\"^/agents/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/agents/city/:hubSlug\",\"regex\":\"^/agents/city/([^/]+)$\",\"paramNames\":[\"hubSlug\"],\"hasOptionalPrefix\":false},{\"path\":\"/agents/county/:hubSlug\",\"regex\":\"^/agents/county/([^/]+)$\",\"paramNames\":[\"hubSlug\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/agents/:agentId\",\"regex\":\"^/admin/agents/([^/]+)$\",\"paramNames\":[\"agentId\"],\"hasOptionalPrefix\":false},{\"path\":\"/embed/agents/:slug\",\"regex\":\"^/embed/agents/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/account/profile\"},{\"path\":\"/account/interactions\"},{\"path\":\"/\"},{\"path\":\"/vendors\"},{\"path\":\"/open-houses\"},{\"path\":\"/agents\"},{\"path\":\"/agents/a-z\"},{\"path\":\"/nar-designations\"},{\"path\":\"/admin\"},{\"path\":\"/admin/hero\"},{\"path\":\"/admin/involvement/committees\"},{\"path\":\"/admin/involvement/event-participation\"},{\"path\":\"/admin/involvement/certifications\"},{\"path\":\"/admin/involvement/association\"},{\"path\":\"/admin/standardized\"},{\"path\":\"/admin/config\"},{\"path\":\"/admin/directories\"},{\"path\":\"/admin/directories/provision\"},{\"path\":\"/admin/bridge\"},{\"path\":\"/admin/bridge/unmatched\"},{\"path\":\"/admin/nar\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.11";import posthog from "posthog-js";
import * as Sentry from "@sentry/nextjs";
import { sanitizeSatellitePageLoadCapture } from "@to/ui";
import { sanitizeDirectoryReportingCapture } from "./src/lib/directory-reporting-events";

const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
if (key) {
  posthog.init(key, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    ui_host: "https://us.posthog.com",
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: true,
    autocapture: true,
    capture_performance: { web_vitals: true },
    enable_heatmaps: true,
    capture_dead_clicks: true,
    rageclick: true,
    before_send: (capture) =>
      capture ? sanitizeDirectoryReportingCapture(sanitizeSatellitePageLoadCapture(capture)) : capture,
  });
  posthog.register({
    app: "agentdirectory",
    release: process.env.NEXT_PUBLIC_RELEASE_SHA,
  });
}

// Browser-side Sentry. Gated on NEXT_PUBLIC_SENTRY_DSN (single kill switch),
// matching the PostHog pattern above. Captures unhandled exceptions, traces,
// and session replays (10% of sessions, 100% of sessions with an error).
const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const sentryEnvironment =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: false,
    tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    environment: sentryEnvironment,
    release: process.env.NEXT_PUBLIC_RELEASE_SHA,
    integrations: [
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
  });
}

// Required by @sentry/nextjs to instrument App Router client-side navigations.
// Safe to export unconditionally — it no-ops when Sentry isn't initialized.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
